import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { CreateDriverRequestBody, PatchDriverRequestBody } from '@/api/apis/resources';
import { bannedDriversQueryKeys } from '@/queries/banned-drivers/banned-drivers.keys';

type RemoveBannedDriverMutationVars = {
  id: string;
};

export const useCreateBannedDriverMutation = () => {
  return useMutation({
    mutationFn: (variables: CreateDriverRequestBody) => api.resource.createBannedDriver(variables),
    meta: {
      invalidates: [bannedDriversQueryKeys.getList()],
    },
  });
};

export const useUpdateBannedDriverMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchDriverRequestBody & { id: string }) => api.resource.updateBannedDriver(variables),
    meta: {
      invalidates: [bannedDriversQueryKeys.getList()],
    },
  });
};

export const useRemoveBannedDriverMutation = () => {
  return useMutation({
    mutationFn: (variables: RemoveBannedDriverMutationVars) => api.resource.removeBannedDriver(variables.id),
    meta: {
      invalidates: [bannedDriversQueryKeys.getList()],
    },
  });
};
